import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "21",
  viewBox: "0 0 28 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m12.089 12.016 4.088 2.798-8.536 6.098zM9.355 6.511l2.829-3.773h9.085l-6.813 6.815h9.085l-4.765 3.404zm-3.986 5.314 2.184-2.912 4.256 2.912z" }, null, -1),
    _createElementVNode("path", { d: "m27.08 16.501-1.694 2.476L1.269 2.476 2.963 0z" }, null, -1)
  ]))]))
}
export default { render: render }